!((document, Drupal) => {
  'use strict';

  /**
   * Footer Navbar menu JS
   */
  Drupal.behaviors.footerNavbar = {
    attach: (context) => {
      once('footerNavbar', '.js-footer-menu-toggle-btn', context).
        forEach(menuToggleBtn => {
          const footerNavbar = document.querySelector('.js-footer-navbar');

          menuToggleBtn.addEventListener('click', () => {
            if (menuToggleBtn.classList.contains('on')) {
              menuToggleBtn.classList.remove('on');
              menuToggleBtn.classList.add('off');

              footerNavbar.classList.remove('open');
              footerNavbar.classList.add('close');
            }
            else {
              menuToggleBtn.classList.remove('off');
              menuToggleBtn.classList.add('on');

              footerNavbar.classList.remove('close');
              footerNavbar.classList.add('open');
            }
          });
        });
    },
  };

})(document, Drupal, jQuery);
